module.exports = __webpack_public_path__ + "img/picture1.0cd73e03.jpg";